export class HighFrequencyBackupPolicyPlan {
    'resourceTypes';
    'backupSchedules';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<HighFrequencyBackupResourceType>",
            "format": ""
        },
        {
            "name": "backupSchedules",
            "baseName": "backupSchedules",
            "type": "Array<HighFrequencyBackupSchedules>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HighFrequencyBackupPolicyPlan.attributeTypeMap;
    }
    constructor() {
    }
}
